import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ENTITY_NAMES, ORGANIZATION_TYPES, RECORD_STATUS_VALUES } from '../../shared/constants/api-constants';
import { StatusUpdateService } from 'src/app/business-service/status-update/status-update.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { LeadEmailInputComponent } from '../../shared/popover/lead-email-input/lead-email-input.component';
import { SendViaSocialMediaComponent } from '../../shared/popover/send-via-social-media/send-via-social-media.component';
import { EmailService } from '../../shared/services/email/email.service';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';
import { PdfService } from '../../shared/services/pdf.service';

@Component({
  selector: 'app-itinerary-view',
  templateUrl: './itinerary-view.component.html',
  styleUrls: ['./itinerary-view.component.scss'],
})
export class ItineraryViewComponent implements OnInit {
  @ViewChild('sendthishtmldivtag', { static: false }) sendthishtmldivtag!: ElementRef;

  leadId: any;
  clientId: any

  itineraryId: any;
  allItineraryDetails: any;

  itineraryStatus: any;
  detailsFormData: any;
  routeCraftFormData: any;
  inclusionsAndExclusionsFormData: any;
  termsAndConditionsFormData: any;
  cancellationPolicyFormData: any;
  importantInformationFormData: any;
  notesFormData: any;

  // Constants
  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;

  constructor(
    private _invetoryService: InventoryService,
    private _modalController: ModalController,
    private _statusUpdateService: StatusUpdateService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _popoverController: PopoverController,
    private _emailService: EmailService,
    private _globalService: GlobalService,
    private _pdfServie: PdfService
  ) { }

  ngOnInit() {
    if (this.itineraryId) {
      this._invetoryService.getInventoryItinerary(this.itineraryId).subscribe((data) => {
        this.allItineraryDetails = data;
        this.itineraryStatus = this.allItineraryDetails.itineraryDetails.status;
        this.detailsFormData = this.allItineraryDetails.itineraryDetails;
        this.routeCraftFormData = this.allItineraryDetails.routeCrafts;
        this.inclusionsAndExclusionsFormData = this.allItineraryDetails.inclusionAndExclusions;
        this.termsAndConditionsFormData = this.allItineraryDetails.termsAndConditions;
        this.cancellationPolicyFormData = this.allItineraryDetails.cancellationPolicies;
        this.importantInformationFormData = this.allItineraryDetails.importantInformations;
        this.notesFormData = this.allItineraryDetails.notes;
      })
    }
  }

  closeModal() {
    this._modalController.dismiss();
  }

  async editInventoryItinerary() {
    await this._modalPopupService.closeAllModals();
    await this._modalPopupService.openItineraryForm(null, null, null, this.itineraryId, null)
  }

  async createQuote() {
    this._modalController.dismiss({
      createQuote: true
    });
  }

  approveInventoryItinerary() {
    this._statusUpdateService.updateStatusOfRecord(ENTITY_NAMES.INVENTORY_ITINERARY, this.itineraryId, RECORD_STATUS_VALUES.APPROVED).subscribe((data) => {
      this._responseNotificationService.showMessage("Inventory Itinerary Approved!");
      this._reloadService.triggerInventoryItineraryReload()
      this.ngOnInit();
    })
  }

  formatNewLineText(text: string): string {
    return text ? text.replace(/\n/g, '<br>') : '';
  }
  async sendItinerary(event: Event) {
    const popover = await this._popoverController.create({
      component: SendViaSocialMediaComponent,
      event: event,
      cssClass: "popup-component-social-media",
      componentProps: {
        hideWhatsappOption: true,
        onPathSelected: (data: any) => this.onSocialMediaActionOptionSelected(data), // Ensure the function is passed correctly
      }
    })
    return await popover.present()
  }

  onSocialMediaActionOptionSelected(data: any) {
    let selectedOption = data.path;

    switch (selectedOption) {
      case 'email': {
        this.sendItinararyViaEmail();
        break;
      }
    }
  }

  async sendItinararyViaEmail() {
    const htmlContent = this.sendthishtmldivtag.nativeElement.innerHTML;
    const popover = await this._popoverController.create({
      component: LeadEmailInputComponent,
      cssClass: 'large-popover',
      componentProps: {
        itineraryId: this.itineraryId,
        onActionPerformed: (data: any) => {
          if (data) {
            this._emailService.sendItinerary(this.itineraryId, data, htmlContent).subscribe({
              next: () => {
                this._responseNotificationService.showMessage("Itinerary sent via email!");
              },
              error: (error) => {
                console.error('Error sending Itinerary via email:', error);
                this._responseNotificationService.showMessage("Failed to send Voucher via email!", true);
              }
            })
          }
        }
      }
    })
    return await popover.present()
  }

  async downloadPDF() {
    const htmlContent = this.sendthishtmldivtag.nativeElement.innerHTML;    
    const payload = {
      content: htmlContent
    };

    this._invetoryService.getInventoryItineraryHtml(payload).subscribe({
      next: (res)=>{
        this.downloadItineraryPdf(res);
      },
      error: (err)=>{
        console.log(err);
        this._responseNotificationService.showMessage("Failed to download itineraty, please try again later", true);  
      }
    })
  }

  downloadItineraryPdf(htmlContent:any): void {
    this._pdfServie.generatePdf(htmlContent, false).subscribe(
      (blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Itinerary_${this.itineraryId}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  async createQuoteForNewLead(event:any) {
    const recommendedItinerary = {
      recommendedItineraryId: this.itineraryId,
      recommendedItineraryType: ENTITY_NAMES.INVENTORY_ITINERARY
    };
    this._globalService.setRecommendedItinerary(recommendedItinerary);

    let cType = localStorage.getItem("CType");
    let modalData: any;
    if (cType === ORGANIZATION_TYPES.AGENT) {
      await this._modalPopupService.closeAllModals();
      modalData = await this._modalPopupService.openLeadForm(null, null);
    } else if (cType === ORGANIZATION_TYPES.DMC) {
      await this._modalPopupService.closeAllModals();
      modalData = await this._modalPopupService.openDmcLeadForm(null);
    } else if (cType === ORGANIZATION_TYPES.AGENT_AND_DMC) {
      await this.openAgentDmcLeadPopover(event)
    }



    if (modalData) {
      this._globalService.setRecommendedItinerary(undefined);
    }
  }

  async openAgentDmcLeadPopover(event: any) {
    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: {
          options: [
            { value: "Agent Lead", path: "agentLead" },
            { value: "DMC Lead", path: "dmcLead" }
          ]
        },
        onPathSelected: (data: any) => this.onPrintOptionSelected(data)
      }
    });
    return await popover.present();
  }

  async onPrintOptionSelected(data: any) {
    await this._modalPopupService.closeAllModals();
    this._popoverController.dismiss();
    switch (data.path) {
      case "agentLead": {
        let modalData:any = await this._modalPopupService.openLeadForm(null, null);
        if(modalData){
          this._globalService.setRecommendedItinerary(undefined);
        }
        break;
      }
      case "dmcLead": {
        let modalData:any = await this._modalPopupService.openDmcLeadForm(null);
        if(modalData){
          this._globalService.setRecommendedItinerary(undefined);
        }
        break;
      }
    }    
  }
}
